import React from 'react'
import PropTypes from 'prop-types'
import debounce from 'lodash/debounce'
import { useModelValue } from '@morningtrain/react-resources'
import { usePipeline } from '@morningtrain/react-helpers'

function TriggerPipelineOnDebounce (props) {
  const pipeline = usePipeline()

  const initialAdjustment = useModelValue('adjustment')

  const [adjustment, setAdjustment] = React.useState(initialAdjustment)

  React.useEffect(() => {
    if (initialAdjustment === adjustment) {
      return
    }

    debouncer.current(adjustment)
  }, [adjustment])

  const debouncer = React.useRef(
    debounce(
      (newAdjustment) => {
        triggerPipeline(newAdjustment)
      },
      500
    )
  )

  const handleClick = (e) => {
    e.preventDefault()
    e.stopPropagation()

    setAdjustment(adjustment + props.step)
  }

  const triggerPipeline = (newAdjustment) => {
    const payload = {
      adjustment: newAdjustment
    }

    pipeline.trigger(payload).catch(function (err) {
      return console.log('caught error', err)
    })
  }

  return React.createElement(React.Fragment, null, React.Children.map(props.children, function (child) {
    return React.cloneElement(child, {
      onClick: function onClick (e) {
        return handleClick(e)
      }
    })
  }))
}

TriggerPipelineOnDebounce.defaultProps = {}

TriggerPipelineOnDebounce.propTypes = {
  step: PropTypes.number.isRequired
}

export default TriggerPipelineOnDebounce
